"use strict";

import $ from 'jquery';

const FORM_SELECTOR = '#sport-participation-form';

export default  {
    wireup : function (){

        let theForm = $(FORM_SELECTOR);
        theForm.validate();

        theForm.find('.selectize')
            .selectize({
                create:false,
                openOnFocus: true,
                closeAfterSelect: false,
                selectOnTab: true
            });
    },
    validate : function (){

        let isValid = $(FORM_SELECTOR).valid();

        return new Promise(function(resolve){
            resolve(isValid);
        });
    }
};


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/register/SportParticipationSection.js